<div class="container-fluid mt-3 mb-5">
  <div class="row">
    <div class="col">
      <div class="container-shadow">
        <div class="row">
          <div class="col">
            <h3 class="text-center p-3">Document Types</h3>
          </div>
        </div>
        <div class="row">
          <div class="col m-5 p-5 text-center" *ngIf="loading">
            <i class="fas fa-pulse fa-spinner fa-5x"></i>
          </div>
        </div>
        <div class="row pb-3" *ngIf="!loading">
          <div class="col-sm-6">
            <div class="card ml-3" id="left-card">
              <div class="card-header">
                <div class="float-right">
                  <a href="javascript: void(0)" (click)="$event.stopPropagation(); $event.preventDefault(); newDocumentTypeSet()"><i class="fas fa-plus"></i>&nbsp;New Document Type</a>
                </div>
                Index
              </div>
              <div class="card-body">
                <div class="form-group row">
                  <div class="col">
                    <input type="text" style="width: 200px" class="d-inline-block form-control form-control-sm" placeholder="Search" [(ngModel)]="params.term" (keyup)="nextTerm()" type="text" />
                  </div>
                  <div class="col">
                    <div class="custom-control custom-checkbox custom-control-inline">
                      <input type="checkbox" class="custom-control-input" [(ngModel)]="params.show_inactive" />
                      <label class="custom-control-label" (click)="params.show_inactive = !params.show_inactive; loadDocumentTypes(true)">Show Inactive</label>
                    </div>
                  </div>
                </div>
              </div>
              <ul class="list-group list-group-flush">
                <li class="list-group-item cursor-pointer" *ngFor="let documentType of documentTypes">
                  <a href="javascript: void(0)" (click)="$event.stopPropagation(); $event.preventDefault(); toggleDocumentType(documentType)">
                    <i class="fas font-weight-bold text-primary" [ngClass]="{ 'fa-plus-circle': !documentType.expanded, 'fa-minus-circle': documentType.expanded }"></i>
                  </a>
                  <span class="font-weight-bold">&nbsp;{{ documentType.prefix }} - </span>
                  <span [ngClass]="{ 'text-muted': !documentType.is_active }">{{ documentType.name }}</span
                  >&nbsp;
                  <a href="javascript: void(0)" [ngClass]="{ 'text-secondary': selectedDocumentType && selectedDocumentType.id == documentType.id }" (click)="$event.stopPropagation(); $event.preventDefault(); selectDocumentType(documentType)">View</a>
                  <br *ngIf="documentType.expanded" />
                  <app-document-type-list
                    *ngIf="documentType.expanded"
                    [selectedDocumentTypeId]="selectedDocumentType ? selectedDocumentType.id : newParentId"
                    [documentTypes]="documentType.children"
                    [updatedDocumentTypeNumber]="updatedDocumentTypeNumber"
                    (selectedDocumentType)="selectDocumentType($event)"
                  ></app-document-type-list>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="card mr-3" id="right-card" *ngIf="selectedDocumentType || newDocumentType" [ngStyle]="{ marginTop: rightMarginTop }">
              <div class="card-body" *ngIf="newDocumentType">
                <h5>New Document Type</h5>
                <div>
                  <div class="form-group">
                    <label>Prefix</label>
                    <input type="text" class="form-control" [(ngModel)]="newDocumentType.prefix" />
                  </div>
                  <div class="form-group">
                    <label>Name</label>
                    <input type="text" class="form-control" [(ngModel)]="newDocumentType.name" />
                  </div>
                  <div class="form-group">
                    <label>Description</label>
                    <textarea type="text" class="form-control" [(ngModel)]="newDocumentType.description"></textarea>
                  </div>
                  <div class="form-group">
                    <div class="custom-control custom-checkbox">
                      <input type="checkbox" [(ngModel)]="newDocumentType.is_active" class="custom-control-input" />
                      <label class="custom-control-label" (click)="newDocumentType.is_active = !newDocumentType.is_active">Is Active</label>
                    </div>
                  </div>
                  <div class="form-group text-center">
                    <button [disabled]="saving" type="button" (click)="saveDocumentType(newDocumentType)" class="btn btn-primary">Save</button>
                    &nbsp;
                    <button [disabled]="saving" type="button" class="btn btn-secondary" (click)="newDocumentType = null">Cancel</button>
                  </div>
                </div>
              </div>
              <div class="card-body" *ngIf="selectedDocumentType">
                <h5 class="card-title">
                  {{ selectedDocumentType.prefix }} - {{ selectedDocumentType.name }}
                  &nbsp;
                  <app-badge badgeType="success" *ngIf="selectedDocumentType.is_active">
                    Active
                  </app-badge>
                  <app-badge badgeType="danger" *ngIf="!selectedDocumentType.is_active">
                    Inactive
                  </app-badge>
                </h5>
                <p class="card-text text-secondary">{{ selectedDocumentType.description }}</p>
                <a (click)="$event.stopPropagation(); $event.preventDefault(); editDocumentTypeSet()" href="javascript: void(0)" class="card-link text-primary"><i class="fas fa-pencil-alt"></i> Edit</a>
                <a (click)="$event.stopPropagation(); $event.preventDefault(); deleteDocumentType(selectedDocumentType)" href="javascript: void(0)" class="card-link text-danger"><i class="fas fa-trash"></i> Delete</a>
                <a (click)="$event.stopPropagation(); $event.preventDefault(); addChildDocumentTypeSet()" href="javascript: void(0)" class="card-link text-primary"><i class="fas fa-plus"></i> Add Child</a>
                <br />
                <div *ngIf="editDocumentType">
                  <div class="form-group font-italic pt-2">Editing Document Type</div>
                  <div class="form-group">
                    <label>Prefix</label>
                    <input type="text" class="form-control" [(ngModel)]="editDocumentType.prefix" />
                  </div>
                  <div class="form-group">
                    <label>Name</label>
                    <input type="text" class="form-control" [(ngModel)]="editDocumentType.name" />
                  </div>
                  <div class="form-group">
                    <label>Description</label>
                    <textarea type="text" class="form-control" [(ngModel)]="editDocumentType.description"></textarea>
                  </div>
                  <div class="form-group">
                    <div class="custom-control custom-checkbox">
                      <input type="checkbox" [(ngModel)]="editDocumentType.is_active" class="custom-control-input" />
                      <label class="custom-control-label" (click)="editDocumentType.is_active = !editDocumentType.is_active">Is Active</label>
                    </div>
                  </div>
                  <div class="form-group text-center">
                    <button [disabled]="saving" type="button" (click)="saveDocumentType(editDocumentType)" class="btn btn-primary">Save</button>
                    &nbsp;
                    <button [disabled]="saving" type="button" class="btn btn-secondary" (click)="editDocumentType = null">Cancel</button>
                  </div>
                </div>
                <div *ngIf="addChildDocumentType">
                  <div class="form-group font-italic pt-2">Adding Child</div>
                  <div class="form-group">
                    <label>Prefix Letter</label>
                    <select (change)="addChildDocumentType.prefix = selectedDocumentType.prefix + addChildDocumentType.prefix_letter" class="form-control" [(ngModel)]="addChildDocumentType.prefix_letter">
                      <option [value]="prefixLetter" *ngFor="let prefixLetter of formOptions.prefixes">
                        {{ prefixLetter }}
                      </option>
                    </select>
                  </div>
                  <div class="form-group">
                    <label>Name</label>
                    <input type="text" class="form-control" [(ngModel)]="addChildDocumentType.name" />
                  </div>
                  <div class="form-group">
                    <label>Description</label>
                    <textarea type="text" class="form-control" [(ngModel)]="addChildDocumentType.description"></textarea>
                  </div>
                  <div class="form-group">
                    <div class="custom-control custom-checkbox">
                      <input type="checkbox" [(ngModel)]="addChildDocumentType.is_active" class="custom-control-input" />
                      <label class="custom-control-label" (click)="addChildDocumentType.is_active = !addChildDocumentType.is_active">Is Active</label>
                    </div>
                  </div>
                  <div class="form-group text-center">
                    <button [disabled]="saving" type="button" class="btn btn-primary" (click)="saveDocumentType(addChildDocumentType)">Save</button>
                    &nbsp;
                    <button [disabled]="saving" type="button" class="btn btn-secondary" (click)="addChildDocumentType = null">Cancel</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
